// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__2WAau","cross":"style_cross__3BXiF"};